import {LineupsMemberInjuryApiModel} from "./lineups-member-injury-api-model";
import {LINEUPS} from "../../../../../widgets/lineups-widget/lineups-widget.consts";
import {BaseDomainModel} from "../../../../../infrastructure/models/base-domain-model";

export class LineupsMemberInjuryDomainModel extends BaseDomainModel {
  apiModel: LineupsMemberInjuryApiModel;

  get imageId(): Number {
    return this.apiModel.imageId;
  }

  get categoryId(): LINEUPS.INJURY_CATEGORY{
    return this.apiModel.categoryId;
  }

  get reason(): String{
    return this.apiModel.reason;
  }

  get expectedReturn(): String{
    return this.apiModel.expectedReturn;
  }
}
